/* eslint-disable */
export default {
  419: 'América Latina',
  AR: 'Argentina',
  AT: 'Áustria',
  AU: 'Austrália',
  BE: 'Bélgica',
  BG: 'Bulgária',
  BH: 'Bahrein',
  BJ: 'Benin',
  BR: 'Brasil',
  CA: 'Canadá',
  CH: 'Suíça',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colômbia',
  CY: 'Chipre',
  CZ: 'República Tcheca',
  DE: 'Alemanha',
  DK: 'Dinamarca',
  DO: 'República Dominicana',
  EE: 'Estônia',
  ES: 'Espanha',
  FI: 'Finlândia',
  FR: 'França',
  GB: 'Reino Unido',
  GE: 'Geórgia',
  GH: 'Gana',
  GN: 'Guiné',
  GR: 'Grécia',
  HK: 'Hong Kong',
  HR: 'Croácia',
  HU: 'Hungria',
  ID: 'Indonésia',
  IE: 'Irlanda',
  IL: 'Israel',
  IN: 'Índia',
  IT: 'Itália',
  JP: 'Japão',
  KE: 'Quênia',
  KR: 'Coreia do Sul',
  LT: 'Lituânia',
  LU: 'Luxemburgo',
  LV: 'Letônia',
  MX: 'México',
  MY: 'Malásia',
  NG: 'Nigéria',
  NL: 'Países Baixos',
  NO: 'Noruega',
  NZ: 'Nova Zelândia',
  PA: 'Panamá',
  PE: 'Peru',
  PH: 'Filipinas',
  PK: 'Paquistão',
  PL: 'Polônia',
  PR: 'Porto Rico',
  PT: 'Portugal',
  RO: 'Romênia',
  SE: 'Suécia',
  SG: 'Singapura',
  SI: 'Eslovênia',
  SK: 'Eslováquia',
  SV: 'El Salvador',
  TR: 'Turquia',
  TW: 'Taiwan',
  UA: 'Ucrânia',
  US: 'Estados Unidos',
  VN: 'Vietnã',
  ZA: 'África do Sul',
} as const;

// @key: @#@"419"@#@ @source: @#@"Latin America"@#@
// @key: @#@"AR"@#@ @source: @#@"Argentina"@#@
// @key: @#@"AT"@#@ @source: @#@"Austria"@#@
// @key: @#@"AU"@#@ @source: @#@"Australia"@#@
// @key: @#@"BE"@#@ @source: @#@"Belgium"@#@
// @key: @#@"BG"@#@ @source: @#@"Bulgaria"@#@
// @key: @#@"BH"@#@ @source: @#@"Bahrain"@#@
// @key: @#@"BJ"@#@ @source: @#@"Benin"@#@
// @key: @#@"BR"@#@ @source: @#@"Brazil"@#@
// @key: @#@"CA"@#@ @source: @#@"Canada"@#@
// @key: @#@"CH"@#@ @source: @#@"Switzerland"@#@
// @key: @#@"CL"@#@ @source: @#@"Chile"@#@
// @key: @#@"CN"@#@ @source: @#@"China"@#@
// @key: @#@"CO"@#@ @source: @#@"Colombia"@#@
// @key: @#@"CY"@#@ @source: @#@"Cyprus"@#@
// @key: @#@"CZ"@#@ @source: @#@"Czech Republic"@#@
// @key: @#@"DE"@#@ @source: @#@"Germany"@#@
// @key: @#@"DK"@#@ @source: @#@"Denmark"@#@
// @key: @#@"DO"@#@ @source: @#@"Dominican Republic"@#@
// @key: @#@"EE"@#@ @source: @#@"Estonia"@#@
// @key: @#@"ES"@#@ @source: @#@"Spain"@#@
// @key: @#@"FI"@#@ @source: @#@"Finland"@#@
// @key: @#@"FR"@#@ @source: @#@"France"@#@
// @key: @#@"GB"@#@ @source: @#@"United Kingdom"@#@
// @key: @#@"GE"@#@ @source: @#@"Georgia"@#@
// @key: @#@"GH"@#@ @source: @#@"Ghana"@#@
// @key: @#@"GN"@#@ @source: @#@"Guinea"@#@
// @key: @#@"GR"@#@ @source: @#@"Greece"@#@
// @key: @#@"HK"@#@ @source: @#@"Hong Kong"@#@
// @key: @#@"HR"@#@ @source: @#@"Croatia"@#@
// @key: @#@"HU"@#@ @source: @#@"Hungary"@#@
// @key: @#@"ID"@#@ @source: @#@"Indonesia"@#@
// @key: @#@"IE"@#@ @source: @#@"Ireland"@#@
// @key: @#@"IL"@#@ @source: @#@"Israel"@#@
// @key: @#@"IN"@#@ @source: @#@"India"@#@
// @key: @#@"IT"@#@ @source: @#@"Italy"@#@
// @key: @#@"JP"@#@ @source: @#@"Japan"@#@
// @key: @#@"KE"@#@ @source: @#@"Kenya"@#@
// @key: @#@"KR"@#@ @source: @#@"South Korea"@#@
// @key: @#@"LT"@#@ @source: @#@"Lithuania"@#@
// @key: @#@"LU"@#@ @source: @#@"Luxembourg"@#@
// @key: @#@"LV"@#@ @source: @#@"Latvia"@#@
// @key: @#@"MX"@#@ @source: @#@"Mexico"@#@
// @key: @#@"MY"@#@ @source: @#@"Malaysia"@#@
// @key: @#@"NG"@#@ @source: @#@"Nigeria"@#@
// @key: @#@"NL"@#@ @source: @#@"Netherlands"@#@
// @key: @#@"NO"@#@ @source: @#@"Norway"@#@
// @key: @#@"NZ"@#@ @source: @#@"New Zealand"@#@
// @key: @#@"PA"@#@ @source: @#@"Panama"@#@
// @key: @#@"PE"@#@ @source: @#@"Peru"@#@
// @key: @#@"PH"@#@ @source: @#@"Philippines"@#@
// @key: @#@"PK"@#@ @source: @#@"Pakistan"@#@
// @key: @#@"PL"@#@ @source: @#@"Poland"@#@
// @key: @#@"PR"@#@ @source: @#@"Puerto Rico"@#@
// @key: @#@"PT"@#@ @source: @#@"Portugal"@#@
// @key: @#@"RO"@#@ @source: @#@"Romania"@#@
// @key: @#@"SE"@#@ @source: @#@"Sweden"@#@
// @key: @#@"SG"@#@ @source: @#@"Singapore"@#@
// @key: @#@"SI"@#@ @source: @#@"Slovenia"@#@
// @key: @#@"SK"@#@ @source: @#@"Slovakia"@#@
// @key: @#@"SV"@#@ @source: @#@"El Salvador"@#@
// @key: @#@"TR"@#@ @source: @#@"Türkiye"@#@
// @key: @#@"TW"@#@ @source: @#@"Taiwan"@#@
// @key: @#@"UA"@#@ @source: @#@"Ukraine"@#@
// @key: @#@"US"@#@ @source: @#@"United States"@#@
// @key: @#@"VN"@#@ @source: @#@"Vietnam"@#@
// @key: @#@"ZA"@#@ @source: @#@"South Africa"@#@
